export function getLanguage(): string {
  const _window = window as any
  let language = 'en'
  if (_window.testLanguge) {
    language = _window.testLanguge
  }
  let config
  if (
    _window.wixTagManager &&
    typeof _window.wixTagManager.getConfig === 'function'
  ) {
    config = _window.wixTagManager.getConfig()
  }

  if (config && config.geo === 'IL') {
    language = 'he'
  } else if (_window.wixEmbedsAPI) {
    language = _window.wixEmbedsAPI.getLanguage() || 'en'
  } else if (config) {
    language = config.language || 'en'
  }
  return language
}
